export  const  FILES_LIMIT_ERROR = "numbers of files should be less than 6 files";
export const  FILES_SIZE_LIMIT_ERROR = "the size of selected files should be less than or equals to 5MB";
export const  MAX_SIZE_LIMIT = 5000000;
export const  MAX_FILES_LIMIT = 5;
export const SITE_URL = "https://cloud-jot.web.app/"
export const SERVER_URL = "https://still-thicket-19118.herokuapp.com/"
export  const  SECURITY_KEY_NOT_PROVIDED_ERROR = "please enter security key";
export  const  FILES_NOT_SELECTED_ERROR = "please select at least one file";
export const DUMMY_ERROR = "Something went wrong please check your internet connection";
